import { useEffect, useState } from 'react';
import Pagination from '@src/common/Pagination';
import { toast } from 'react-toastify';
import { useDispatch,useSelector } from 'react-redux';
import ConfirmPopUp from '@src/common/ConfirmPopUp';
import { getAgencyList, updateAgencyStatus } from '@src/store/slices/agency';
import FullPageLoader from "@src/common/FullPageLoader";
import ToggleSwitch from '@src/common/ToggleSwitch';
import { Link } from 'react-router-dom';
import { Tooltip as TooltipLite } from 'react-tooltip';
import * as HELPER from '@src/config/helper';
import { DEFAULT_PAGINATION_COUNT, ROLE_FEATURES,INS_INSURANCE_ID_STAGE,DEFAULT_PAGE_NUMBER, STATUS_SUCCESS, PAGE_NUMBER } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";
import { getMasterConfig } from '@src/store/slices/common';
import { AgencyAgentOption } from '../../../store/types/Common';
import ContractPopup from '../../../../src/component/Insurer/ContractPopup';
import {COUNTRY_CODE} from '@src/config/constant';

function AgencyListTable(props: any) {
    const dispatch: any = useDispatch();
    const {translations} = useLanguage();
    let [agencyList, setAgencyList] = useState<[]>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line
    const [filterParam, setFilterParam] = useState({ page_number: PAGE_NUMBER })
    const [partnerNameToolTip, setPartnerNameToolTip] = useState(0);


    const [currentToggle, setCurrentToggle] = useState<any>(null);

    const commonState = useSelector((state: any) => state.common);

     // Variable to define agency_agent_data
    const [agencyAgentData, setAgencyAgentData] = useState<AgencyAgentOption[]>([]);

    const [showContractPopup, setShowContractPopup] = useState<boolean>(false);
    const [selectedAgency, setSelectedAgency] = useState<any>({});
    let [paymentTypeList, setPaymentTypeList] = useState<[]>([]);
    let [contractStatusList, setContractStatusList] = useState<[]>([]);
    let [partnerList, setPartnerList] = useState<[]>([]);
    

    useEffect(() => {
        const getMasterConfigData = async () => {
            if (Object.keys(commonState.common).length === 0) {
                const response: any = await dispatch(getMasterConfig());                
                setAgencyAgentData(response?.data?.agency_agent_data)
                setPaymentTypeList(response?.data?.payment_type)
                setContractStatusList(response?.data?.contract_status)
                setPartnerList(response?.data?.partner_list)

            } else {
                setAgencyAgentData(commonState.common.agency_agent_data)
                setPaymentTypeList(commonState?.common?.payment_type)
                setContractStatusList(commonState?.common?.contract_status)
                setPartnerList(commonState?.common?.partner_list)
            }
        }
        getMasterConfigData();
        // eslint-disable-next-line
    }, [dispatch, commonState]);

    useEffect(() => {
        let agencyStatus: number = 1;
        if (props?.activeTab === "second") { agencyStatus = 0; }
        if (props?.activeTab === "third") { agencyStatus = 2; }
        if (props?.activeTab === "forth") { agencyStatus = 3; }

        const updatedParams = {
            ...filterParam,
            status: agencyStatus,
            searchKeyword: props?.searchKeyword || undefined,
            created_at: props?.selectedFilters?.created_at || undefined,
            approval_date:props?.selectedFilters?.approval_date || undefined,
            reporting_to_role:props?.selectedFilters?.reporting_to_role || undefined,
            reporting_to_name:props?.selectedFilters?.reporting_to_name || undefined,
        };
        // fetchAgency({ ...filterParam, status: agencyStatus, searchKeyword: props?.searchKeyword || undefined })


        const {
            created_at,
            approval_date,
            reporting_to_role,
            reporting_to_name,
        } = props?.selectedFilters || {};
    
        const hasFilterChange =
            props?.searchKeyword ||
            created_at ||
            approval_date ||
            reporting_to_role ||
            reporting_to_name;

        if(hasFilterChange) updatedParams.page_number = DEFAULT_PAGE_NUMBER;


        setFilterParam(updatedParams);
        fetchAgency(updatedParams);

        // eslint-disable-next-line
    }, [props?.activeTab, props?.searchKeyword,props?.selectedFilters?.created_at,props?.selectedFilters?.approval_date,props?.selectedFilters?.reporting_to_role,props?.selectedFilters?.reporting_to_name])

    const confirmNo = () => {
        setShowConfirmation(false);
        setCurrentToggle({});
    };


    const handleRequestData = (params: any) => {

        let agencyStatus: number = 1;
        if (props?.activeTab === "second") { agencyStatus = 0; }
        if (props?.activeTab === "third") { agencyStatus = 2; }
        if (props?.activeTab === "forth") { agencyStatus = 3; }

        // let apiParams = {
        //     page_number: params.page_no,
        //     searchKeyword: props?.searchKeyword || undefined,
        //     status: agencyStatus
        // }
        // fetchAgency(apiParams);
        setFilterParam((prevFilterParam) => {
            const updatedFilter = {
                ...prevFilterParam,
                page_number: params.page_no,
                searchKeyword: props?.searchKeyword || undefined,
                created_at: props?.selectedFilters?.created_at || undefined,
                approval_date:props?.selectedFilters?.approval_date || undefined,
                reporting_to_role:props?.selectedFilters?.reporting_to_role || undefined,
                reporting_to_name:props?.selectedFilters?.reporting_to_name || undefined,
                status: agencyStatus,
            };
            fetchAgency(updatedFilter);
    
            return updatedFilter;
        });
    }

    const fetchAgency = (params: any) => {
        setLoading(true)
        getAgencyList(params).then((res: any) => {
            setLoading(false)

            if (res.status === STATUS_SUCCESS) {
                setAgencyList(res.data)
                setPaginationData(res.pagination)
                props.updateTabCount(res.tabCount)
            }
        }).catch(err => setLoading(false))
    }

    const handleToggleSwitch = (element: any) => {
        setCurrentToggle(element);
        setShowConfirmation(true);
    };

    const confirmYes = async () => {
        if (currentToggle) {
            const updatedData = { id: currentToggle.id, status: currentToggle.status ? 0 : 1 };
            setLoading(true);

            dispatch(updateAgencyStatus(updatedData)).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    toast.success(res.message);
                    fetchAgency({ ...filterParam, status: (props.activeTab === "first" ? 1 : 0) });

                }
                setLoading(false);
            }).catch((err: Error) => {
                setLoading(false);
            });
        }
        setShowConfirmation(false);

    };

    const hideContractPopup = () => {        
        setShowContractPopup(false);
    }

    const handleContractBtnClick = (agency:any) => {
        setSelectedAgency(agency);
        setShowContractPopup(true);
    }

    return (
        <>
            <FullPageLoader show={loading} />

            <div className="lead-list-data-table agency-Partner-list">
                <table>
                    <thead>
                        {
                            INS_INSURANCE_ID_STAGE ?
                            <tr>
                                <th>{translations.RuleEngineAgency?.['ID'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngineAgency?.['User_Name'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Email'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Mobile_No'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngineAgency?.['User_Role'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngineAgency?.['Manager_Name'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngineAgency?.['Manager_Role'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['status'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['action'] || translations.commonMsg?.loading}</th>
                            </tr>
                            :
                            <tr>
                                <th>ID</th>
                                <th>Agent Name</th>
                                <th>Channel Type</th>
                                <th>Email</th>
                                <th>Mobile No.</th>
                                <th>Insurance Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        }
                    </thead>
                    <tbody>
                        {(agencyList && agencyList.length > 0) ? agencyList.map((row: any, index: number) => {

                            return (
                                <tr key={index}>
                                    <td title={row?.id}>
                                        {
                                            INS_INSURANCE_ID_STAGE ? 
                                            <Link to={`/agency/detail/${row.hashId}`} >
                                                {row?.id}
                                            </Link>
                                            :
                                            <Link to={`/agency/edit/${row.hashId}`} >
                                                {row?.id}
                                            </Link>
                                        }
                                    </td>
                                    <td title={row?.name}>{row?.name}</td>
                                    { !INS_INSURANCE_ID_STAGE && (() => {
                                        const label = agencyAgentData?.find(item => +item.value === +row.type)?.label;
                                        return <td title={label}>{label}</td>;
                                    })()}
                                    <td title={row?.email}>{row?.email}</td>
                                    <td title={row?.mobile}>{row?.mobile}</td>
                                    {
                                        INS_INSURANCE_ID_STAGE ?
                                        <td title={row?.user_role}>{row?.user_role ?? '-'}</td>
                                        :
                                        <td>
                                            {row?.partner_map?.slice(0, 2).map((partner: any) => partner)?.join(",")}
                                            <span className='more-txt tooltio-ic' data-tooltip-id="my-tooltip-2" onClick={() => setPartnerNameToolTip(row.id)} onMouseLeave={() => { }}> {((row?.partner_map?.length > 2) ? ` +${row?.partner_map?.length - 2} more` : '')} </span>
                                            {
                                                partnerNameToolTip === row.id &&
                                                <div className='tooltip-outer'>


                                                    <TooltipLite
                                                        isOpen={partnerNameToolTip === row.id}
                                                        className=" react-tooltip-lite"

                                                        id="my-tooltip-2"
                                                        place="bottom"
                                                        clickable={true}
                                                        render={() =>
                                                            <div className="controlled-example tooltip-main">
                                                                <div className="tooltip-data">

                                                                    <span className="controlled-example_close-button" onClick={() => { setPartnerNameToolTip(0); }}><i className="ic-clearclose"></i></span>
                                                                    <ul className="user-detail">
                                                                        {
                                                                            row?.partner_map?.map((partner: any) =>
                                                                                <li>
                                                                                    <label>{partner}</label>
                                                                                </li>
                                                                            )
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        }

                                                    />
                                                </div>
                                            }


                                        </td>
                                    }
                                    {
                                        INS_INSURANCE_ID_STAGE &&
                                        (
                                            <>
                                                <td title={row?.manager_name}>{row?.manager_name ?? '-'}</td>
                                                <td title={row?.manager_role}>{row?.manager_role ?? '-'}</td>
                                            </>
                                        ) 
                                    }
                                    <td>
                                        <div className="on-off-switch">
                                            {([0, 1].includes(row.status))
                                                ?
                                                (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' })) ?
                                                <ToggleSwitch checked={row.status} onChange={() => handleToggleSwitch(row)} />
                                                
                                                :<ToggleSwitch checked={row.status} />
                                                :
                                                <p className=''>{row.status === 2 ? translations.RuleEngineAgency?.['In_progress'] || translations.commonMsg?.loading : translations.RuleEngineAgency?.['Rejected'] || translations.commonMsg?.loading}</p>

                                            }

                                        </div>
                                    </td>
                                    <td>
                                        <ul className="action-btn">
                                            <li >
                                                {
                                                    INS_INSURANCE_ID_STAGE ?
                                                        <Link to={`/agency/detail/${row.hashId}`} >
                                                            <i className='ic-remove_red_eyevisibility'></i>
                                                        </Link>
                                                        :
                                                        <Link to={`/agency/edit/${row.hashId}`} >
                                                            <i className='ic-remove_red_eyevisibility'></i>
                                                        </Link>
                                                }
                                            </li>
                                            {
                                                (COUNTRY_CODE !== 'id') &&
                                                <li title="View Contracts" onClick={() => { handleContractBtnClick(row) }}>
                                                    <i className='ic-application' style={{ cursor: 'pointer', fontSize: '16px' }}></i>
                                                </li>
                                            }
                                        </ul>
                                    </td>

                                </tr>)

                        })
                            :
                            <tr><td colSpan={8} style={{ textAlign: 'center' }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</td></tr>
                        }
                    </tbody>
                </table>
                {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination paginateData={{
                    page: 1,
                    loading: false,
                    tableData: paginationData['limit'],
                    totalLengthWithoutPagination: paginationData['total'],
                    paginationData,
                    filteredData: {}
                }}
                    sendRequestDataToParent={handleRequestData} />}

                {showConfirmation === false ? ("") : (
                    <ConfirmPopUp
                        confirmNo={confirmNo}
                        confirmYes={confirmYes}
                        message={`${translations.RuleEngineAgency?.['Are_you_sure_msg'] || translations.commonMsg?.loading} ${currentToggle.name} ${currentToggle.status === 0 ? translations.RuleEngineAgency?.['As_Active'] || translations.commonMsg?.loading: translations.RuleEngineAgency?.['As_Inactive'] || translations.commonMsg?.loading} ?`} />
                )}
            </div>
            <ContractPopup
                showContractPopup={showContractPopup}
                handleModalClose={hideContractPopup}
                selectedAgency={selectedAgency}
                paymentTypeList={paymentTypeList}
                contractStatusList={contractStatusList}
                partnerList={partnerList}
                from={"agencyList"}
                handleLoading={setLoading}
            />

        </>

    )
}

export default AgencyListTable

